/**
 * Forgot Password page - same layout as Login/Signup (header, main, footer).
 */

import React from 'react';
import RequestPasswordReset from '../../components/auth/RequestPasswordReset';
import { PublicHeader, PublicFooter } from '../../components/public';

const ForgotPassword = () => (
  <div className="auth-page-layout">
    <PublicHeader />
    <main className="auth-page-main">
      <RequestPasswordReset />
    </main>
    <PublicFooter />
  </div>
);

export default ForgotPassword;
